import { Link2 } from "lucide-react-native";
import { FC } from "react";

import { HStack, Text } from "@/components/ui";
import { useLocalization } from "@/hooks";
import { Question } from "@/types/resources";

interface CarryForwardBadgeProps {
  allQuestions: Question[];
  carryForward: Question["carry_forward"];
}

const CarryForwardBadge: FC<CarryForwardBadgeProps> = ({
  allQuestions,
  carryForward,
}) => {
  const { i18n } = useLocalization();

  if (carryForward === null) return null;

  const sourceQuestion = allQuestions.find(
    (q) => q.id === carryForward.source_question_id
  );

  const { filter } = carryForward;
  const number = sourceQuestion?.order ?? "?";

  let badgeText: string;
  if (filter.type === "selected") {
    badgeText = i18n.t("questions.carryForward.selected", { number });
  } else {
    const minIndex = (filter.min_value ?? 1) - 1;
    const label =
      sourceQuestion?.options[minIndex] ?? `${filter.min_value ?? 1}`;
    badgeText = i18n.t("questions.carryForward.minRating", { label, number });
  }

  if (carryForward.exclude_source_question_id) {
    const excludeQuestion = allQuestions.find(
      (q) => q.id === carryForward.exclude_source_question_id
    );
    const excludeNumber = excludeQuestion?.order ?? "?";
    badgeText += ` ${i18n.t("questions.carryForward.exclude", { number: excludeNumber })}`;
  }

  return (
    <HStack className="items-center gap-1.5 bg-primary-50 dark:bg-primary-900/20 rounded-md px-2.5 py-1.5">
      <Link2 className="text-primary-700 dark:text-primary-300" size={13} />
      <Text className="text-sm font-medium text-primary-700 dark:text-primary-300">
        {badgeText}
      </Text>
    </HStack>
  );
};

export default CarryForwardBadge;
